import { ContactManagementConfigContext } from '../../../../ui/providers';
import React from 'react';
import { useAccountFilter } from './useAccountFilter';
/**
 * Converts from frontend account filter to backend storage client filter.
 * Resolves account filter customizations and will return not just Contact management but also customized filters.
 * Use this hook if you have entity that references account and want to display account filter in that table.
 */
export function useResolvedAccountFilter(params) {
    var _a;
    const { accountsTableCustomization } = React.useContext(ContactManagementConfigContext);
    const resolvedHook = (_a = accountsTableCustomization === null || accountsTableCustomization === void 0 ? void 0 : accountsTableCustomization.overrideUseAccountFilter) !== null && _a !== void 0 ? _a : useAccountFilter;
    return resolvedHook(params);
}
